import { RichTextWUT } from '@wix/form-fields/wut';

export default RichTextWUT;
